import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import ConfirmModal from "components/shared-components/ConfirmModal";
import { useCancelOrder, useCancelOrderReasonList } from "hooks";

const CancelOrder = ({ orderDetail, refetchDetail }) => {
  const { t } = useTranslation(["bloodOrder"]);
  const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);

  const onSuccessCancelOrder = () => {
    refetchDetail();
    setIsOpenCancelModal(false);
  };
  const { mutate: cancelOrder } = useCancelOrder(onSuccessCancelOrder);
  const { refetch: onFetchReason, data: reasonListData } =
    useCancelOrderReasonList(1);

  const handleCancelOrder = value => {
    if (value.reasonId) {
      cancelOrder({
        orderId: orderDetail.id,
        reason_note: value.note,
        reason_id: value.reasonId,
        order_code: orderDetail.order_code,
      });
      setIsOpenCancelModal(false);
    }
  };

  useEffect(() => {
    onFetchReason();
  }, []);

  return (
    <>
      <Button color="danger" onClick={() => setIsOpenCancelModal(true)}>
        Huỷ đơn
      </Button>
      <ConfirmModal
        isOpen={isOpenCancelModal}
        titleHeader={`${t("action.cancel.title", {
          order_code: orderDetail?.order_code,
        })} ?`}
        titleBody={t("action.cancel.description")}
        onConfirm={handleCancelOrder}
        textBtnConfirm={t("button.submit")}
        textBtnCancel={t("button.cancel")}
        toggle={() => setIsOpenCancelModal(false)}
        isReasonDeleteCheckbox={true}
        reasonList={reasonListData?.items}
        isHaveNote={true}
      />
    </>
  );
};

export default CancelOrder;
